import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProtectedRoutes from './components/Auth/ProtectedRoutes'
import AddUser from "./pages/AddUser";

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Switch>
            <Route exact path="/" component={Login}/>
            <Route exact path="/forgot-password" component={ForgotPassword}/>
            <Route exact path="/reset-password" component={ResetPassword}/>
            <Route exact path="/add-user" component={AddUser}/>
            <ProtectedRoutes exact path="/admin" component={Admin} />
          </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
